export default __webpack_public_path__ + "static/media/Ballroll_00311.6e1f9bca.png";